import { Typography } from '@mui/material'

const ChartEditor = () => (
    <Typography>Chart editor coming soon</Typography>
)

export default ChartEditor
